import styled from 'styled-components';

import {BREAKPOINTS} from '../styles';

const GRID = {
  GAP: {
    SMALL: '16px',
    MEDIUM: '24px',
    LARGE: '32px',
  },
  GUTTER: {
    SMALL: '16px 16px 32px',
    MEDIUM: '24px 32px 64px',
    LARGE: '32px 64px 128px',
  },
};

export const PageWidth = styled.div<{ useMaxWidth?: boolean; maxWidth?: number; unsetMargin?: boolean; }>`
  display: block;
  margin: ${GRID.GUTTER.SMALL};
  ${props => props.unsetMargin && 'margin-top: 0; margin-bottom: 0;'}

  ${BREAKPOINTS.MEDIUM} {
    margin: ${GRID.GUTTER.MEDIUM};
    ${props => props.unsetMargin && 'margin-top: 0; margin-bottom: 0;'}
  }

  ${BREAKPOINTS.LARGE} {
    margin: ${GRID.GUTTER.LARGE};
    ${props => props.unsetMargin && 'margin-top: 0; margin-bottom: 0;'}
  }

  ${BREAKPOINTS.LARGE} {
    max-width: ${(props) => (
            props.useMaxWidth
                    ? (props.maxWidth
                            ? 'min(100% - 128px,' + props.maxWidth + 'px)'
                            : 'calc(100% - 128px)')
                    : 'calc(1600px - 128px)')};

    margin: 32px auto 128px;
    ${props => props.unsetMargin && 'margin-top: 0; margin-bottom: 0;'}
  }
`;

export const Columns = styled.section<{ gap?: string; columns?: string; printColumns?: string }>`
  width: 100%;
  display: grid;
  grid-gap: ${(props) => props.gap || GRID.GAP.SMALL};
  word-break: break-word; /* Prevent long words from breaking the layout – consider making this rule global */

  ${BREAKPOINTS.MEDIUM} {
    grid-template-columns: ${(props) => props.columns};
    -ms-grid-columns: ${(props) => props.columns};
    grid-gap: ${(props) => props.gap || GRID.GAP.MEDIUM};
  }

  ${BREAKPOINTS.LARGE} {
    grid-gap: ${(props) => props.gap || GRID.GAP.LARGE};
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: -ms-grid;

    > *:not(:first-child) {
      margin-left: ${GRID.GAP.MEDIUM};
    }
  }

  @media print {
    grid-gap: 0;
    grid-template-columns: ${(props) => props.printColumns || 'none'};
  }
`;
